import common from "commons/languages/english";

const trans = {
  program_name: "DS Commerce",
  version: "3.0.0",
};

export default { ...common, ...trans };
